import { IInput, LandingPageConfig } from '../app-model/config';

export const loginConfig = {
  productLogo: 'A base 64 image',
  social: ['FACEBOOK', 'GOOGLE', 'LINKEDIN'],
  carouselImages: [
    'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Bananas.svg/1024px-Bananas.svg.png',
    'https://i.pinimg.com/736x/5b/2c/41/5b2c415c4ab30e70201b18105a96915c.jpg',
    'https://i.pinimg.com/originals/2a/97/ee/2a97ee006b5a6f34719889fb330bdc76.jpg',
  ],
  carouselHeader: [
    { key: 'carouselHeader1' },
    { key: 'carouselHeader2' },
    { key: 'carouselHeader3' },
  ],
  carouselText: [
    { key: 'carouselText1' },
    { key: 'carouselText2' },
    { key: 'carouselText3' },
  ],
  fieldProperties: [
    {
      type: 'text',
      label: {
        key: 'loginConfigEmailAddressLabelKey',
        defaultValue: 'Email Address',
      },
      placeholder: {
        key: 'loginConfigEmailAddressPlaceholderKey',
        defaultValue: 'Enter Email Address',
      },
      aria: 'email',
      name: 'email',
      subtype: 'email',
      required: true,
      visibility: true,
      requiredMessage: {
        key: 'loginConfigEmailRequiredKey',
        defaultValue: 'Email is required',
      },
    },
    {
      type: 'text',
      label: {
        key: 'loginConfigPasswordLabelKey',
        defaultValue: 'Password',
      },
      placeholder: {
        key: 'loginConfigPasswordsPlaceholderKey',
        defaultValue: 'Enter Password',
      },
      aria: 'password',
      name: 'password',
      subtype: 'password',
      required: true,
      visibility: true,
    },
  ],
  loginButtonText: {
    key: 'signinText',
    defaultValue: 'Custom Sign In',
  },
};
